<template>
  <div class="d-flex">
    <div class="w-100">
      <p class="mb-0 bold">
        <strong>{{event.heading}}</strong>
      </p>
      <p class="mb-0" v-for="(line, index) in event.summary_lines" :key="index">
        {{line}}
      </p>
      <p class="mb-0">
        <icon :name="icon_name" size="22"></icon>
        {{event.status_text}}
      </p>
    </div>
    <div class="d-flex flex-column justify-content-center">
      <p class="mb-0">&gt;</p>
    </div>
  </div>
</template>


<script>
import Icon from '@/components/Icon'

export default {
  name: 'EventCard',
  props: ['event'],
  components: { icon: Icon },
  computed: {
    last_update () {
      if (this.event.previous_actions.length > 0) {
        const action = this.event.previous_actions[this.event.previous_actions.length - 1]
        return action.created_at
      }
    },
    icon_name () {
      if (this.event.status === 'waiting') {
        return 'wait'
      } else if (this.event.status === 'closed') {
        return 'closed'
      } else {
        return 'attention'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EventCard.vue